import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _78a40bfb = () => interopDefault(import('../pages/achievement/index.vue' /* webpackChunkName: "pages/achievement/index" */))
const _1a8a3733 = () => interopDefault(import('../pages/advertise/index.vue' /* webpackChunkName: "pages/advertise/index" */))
const _4145a156 = () => interopDefault(import('../pages/agreement/index.vue' /* webpackChunkName: "pages/agreement/index" */))
const _5571a608 = () => interopDefault(import('../pages/calendar/index.vue' /* webpackChunkName: "pages/calendar/index" */))
const _74cee2a8 = () => interopDefault(import('../pages/customer/index.vue' /* webpackChunkName: "pages/customer/index" */))
const _610c5864 = () => interopDefault(import('../pages/details/index.vue' /* webpackChunkName: "pages/details/index" */))
const _7704efe8 = () => interopDefault(import('../pages/goals/index.vue' /* webpackChunkName: "pages/goals/index" */))
const _4500a432 = () => interopDefault(import('../pages/maisoku/index.vue' /* webpackChunkName: "pages/maisoku/index" */))
const _4957b730 = () => interopDefault(import('../pages/media/index.vue' /* webpackChunkName: "pages/media/index" */))
const _7899ffd1 = () => interopDefault(import('../pages/privacy.vue' /* webpackChunkName: "pages/privacy" */))
const _5e156836 = () => interopDefault(import('../pages/project/index.vue' /* webpackChunkName: "pages/project/index" */))
const _51ec974b = () => interopDefault(import('../pages/response/index.vue' /* webpackChunkName: "pages/response/index" */))
const _37db395e = () => interopDefault(import('../pages/sale/index.vue' /* webpackChunkName: "pages/sale/index" */))
const _2607aba8 = () => interopDefault(import('../pages/achievement/output.vue' /* webpackChunkName: "pages/achievement/output" */))
const _af3e0fc0 = () => interopDefault(import('../pages/achievement/registration.vue' /* webpackChunkName: "pages/achievement/registration" */))
const _014fe20b = () => interopDefault(import('../pages/advertise/analysis.vue' /* webpackChunkName: "pages/advertise/analysis" */))
const _43ced232 = () => interopDefault(import('../pages/advertise/management.vue' /* webpackChunkName: "pages/advertise/management" */))
const _78f38430 = () => interopDefault(import('../pages/advertise/registration.vue' /* webpackChunkName: "pages/advertise/registration" */))
const _133d351a = () => interopDefault(import('../pages/calendar/registration.vue' /* webpackChunkName: "pages/calendar/registration" */))
const _10b6965a = () => interopDefault(import('../pages/customer/registration.vue' /* webpackChunkName: "pages/customer/registration" */))
const _533d3692 = () => interopDefault(import('../pages/goals/analysis.vue' /* webpackChunkName: "pages/goals/analysis" */))
const _fa58c3ec = () => interopDefault(import('../pages/goals/setting.vue' /* webpackChunkName: "pages/goals/setting" */))
const _4addaf3e = () => interopDefault(import('../pages/line/tracking/index.vue' /* webpackChunkName: "pages/line/tracking/index" */))
const _95f49f22 = () => interopDefault(import('../pages/maisoku/export.vue' /* webpackChunkName: "pages/maisoku/export" */))
const _7b8dcd16 = () => interopDefault(import('../pages/maisoku/template.vue' /* webpackChunkName: "pages/maisoku/template" */))
const _07d412d0 = () => interopDefault(import('../pages/response/registration.vue' /* webpackChunkName: "pages/response/registration" */))
const _28643f12 = () => interopDefault(import('../pages/sale/output.vue' /* webpackChunkName: "pages/sale/output" */))
const _2fbf2620 = () => interopDefault(import('../pages/setting/announcement/index.vue' /* webpackChunkName: "pages/setting/announcement/index" */))
const _33dd484e = () => interopDefault(import('../pages/setting/import/index.vue' /* webpackChunkName: "pages/setting/import/index" */))
const _5d22945a = () => interopDefault(import('../pages/setting/mail-template.vue' /* webpackChunkName: "pages/setting/mail-template" */))
const _1388eade = () => interopDefault(import('../pages/setting/matching-mail.vue' /* webpackChunkName: "pages/setting/matching-mail" */))
const _a4056f48 = () => interopDefault(import('../pages/setting/shop.vue' /* webpackChunkName: "pages/setting/shop" */))
const _54de2f26 = () => interopDefault(import('../pages/setting/staff/index.vue' /* webpackChunkName: "pages/setting/staff/index" */))
const _1817f6a5 = () => interopDefault(import('../pages/setting/step-mail/index.vue' /* webpackChunkName: "pages/setting/step-mail/index" */))
const _7d0db927 = () => interopDefault(import('../pages/setting/tag/index.vue' /* webpackChunkName: "pages/setting/tag/index" */))
const _6ea4005d = () => interopDefault(import('../pages/shop/document-template/index.vue' /* webpackChunkName: "pages/shop/document-template/index" */))
const _563ebd90 = () => interopDefault(import('../pages/shop/message/index.vue' /* webpackChunkName: "pages/shop/message/index" */))
const _669bdfc6 = () => interopDefault(import('../pages/message/line/edit.vue' /* webpackChunkName: "pages/message/line/edit" */))
const _18ffa990 = () => interopDefault(import('../pages/message/line/log.vue' /* webpackChunkName: "pages/message/line/log" */))
const _e7d07c90 = () => interopDefault(import('../pages/message/line/registration/index.vue' /* webpackChunkName: "pages/message/line/registration/index" */))
const _d0733690 = () => interopDefault(import('../pages/message/line/select.vue' /* webpackChunkName: "pages/message/line/select" */))
const _51795244 = () => interopDefault(import('../pages/message/line/send.vue' /* webpackChunkName: "pages/message/line/send" */))
const _c707e40a = () => interopDefault(import('../pages/message/mail/log.vue' /* webpackChunkName: "pages/message/mail/log" */))
const _1e848f92 = () => interopDefault(import('../pages/message/mail/registration.vue' /* webpackChunkName: "pages/message/mail/registration" */))
const _6fffe715 = () => interopDefault(import('../pages/message/mail/select.vue' /* webpackChunkName: "pages/message/mail/select" */))
const _700c703e = () => interopDefault(import('../pages/message/mail/send.vue' /* webpackChunkName: "pages/message/mail/send" */))
const _1e8eecea = () => interopDefault(import('../pages/setting/announcement/registration.vue' /* webpackChunkName: "pages/setting/announcement/registration" */))
const _56f0ad25 = () => interopDefault(import('../pages/setting/import/Detail.vue' /* webpackChunkName: "pages/setting/import/Detail" */))
const _00e46f26 = () => interopDefault(import('../pages/setting/import/registration.vue' /* webpackChunkName: "pages/setting/import/registration" */))
const _e17a8ab2 = () => interopDefault(import('../pages/setting/real-estate-agent/property-range.vue' /* webpackChunkName: "pages/setting/real-estate-agent/property-range" */))
const _226ad124 = () => interopDefault(import('../pages/setting/staff/registration.vue' /* webpackChunkName: "pages/setting/staff/registration" */))
const _20199a36 = () => interopDefault(import('../pages/setting/step-mail/registration.vue' /* webpackChunkName: "pages/setting/step-mail/registration" */))
const _ef13862e = () => interopDefault(import('../pages/message/line/registration/success.vue' /* webpackChunkName: "pages/message/line/registration/success" */))
const _177e085b = () => interopDefault(import('../pages/index.vue' /* webpackChunkName: "pages/index" */))
const _351d398e = () => interopDefault(import('../pages/message/mail/edit/_id.vue' /* webpackChunkName: "pages/message/mail/edit/_id" */))
const _7486f11a = () => interopDefault(import('../pages/agreement/log/_id.vue' /* webpackChunkName: "pages/agreement/log/_id" */))
const _0dcd4990 = () => interopDefault(import('../pages/agreement/registration/_id.vue' /* webpackChunkName: "pages/agreement/registration/_id" */))
const _06dc274f = () => interopDefault(import('../pages/customer/edit/_id.vue' /* webpackChunkName: "pages/customer/edit/_id" */))
const _735a3114 = () => interopDefault(import('../pages/media/registration/_id.vue' /* webpackChunkName: "pages/media/registration/_id" */))
const _6ecabfa1 = () => interopDefault(import('../pages/project/registration/_id.vue' /* webpackChunkName: "pages/project/registration/_id" */))
const _b29606f6 = () => interopDefault(import('../pages/response/add/_id.vue' /* webpackChunkName: "pages/response/add/_id" */))
const _15c4eb58 = () => interopDefault(import('../pages/setting/announcement/_id.vue' /* webpackChunkName: "pages/setting/announcement/_id" */))
const _61afbbd6 = () => interopDefault(import('../pages/setting/staff/_id.vue' /* webpackChunkName: "pages/setting/staff/_id" */))
const _360d5e4d = () => interopDefault(import('../pages/setting/step-mail/_id.vue' /* webpackChunkName: "pages/setting/step-mail/_id" */))
const _541591a0 = () => interopDefault(import('../pages/shop/message/_id.vue' /* webpackChunkName: "pages/shop/message/_id" */))
const _afaa5dba = () => interopDefault(import('../pages/achievement/_id.vue' /* webpackChunkName: "pages/achievement/_id" */))
const _f14ffd84 = () => interopDefault(import('../pages/agreement/_id.vue' /* webpackChunkName: "pages/agreement/_id" */))
const _fa5be6f8 = () => interopDefault(import('../pages/client-history/_id.vue' /* webpackChunkName: "pages/client-history/_id" */))
const _50856f10 = () => interopDefault(import('../pages/customer/_id.vue' /* webpackChunkName: "pages/customer/_id" */))
const _24c9c598 = () => interopDefault(import('../pages/media/_id.vue' /* webpackChunkName: "pages/media/_id" */))
const _5681f8e6 = () => interopDefault(import('../pages/project/_id.vue' /* webpackChunkName: "pages/project/_id" */))
const _e6e8ca7e = () => interopDefault(import('../pages/property/_property.vue' /* webpackChunkName: "pages/property/_property" */))
const _73a4d355 = () => interopDefault(import('../pages/property/_property/contact/index.vue' /* webpackChunkName: "pages/property/_property/contact/index" */))
const _21255b83 = () => interopDefault(import('../pages/property/_property/contact/confirm.vue' /* webpackChunkName: "pages/property/_property/contact/confirm" */))
const _4f9283d5 = () => interopDefault(import('../pages/property/_property/contact/send.vue' /* webpackChunkName: "pages/property/_property/contact/send" */))
const _cc841f1a = () => interopDefault(import('../pages/response/_id.vue' /* webpackChunkName: "pages/response/_id" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/achievement",
    component: _78a40bfb,
    name: "achievement"
  }, {
    path: "/advertise",
    component: _1a8a3733,
    name: "advertise"
  }, {
    path: "/agreement",
    component: _4145a156,
    name: "agreement"
  }, {
    path: "/calendar",
    component: _5571a608,
    name: "calendar"
  }, {
    path: "/customer",
    component: _74cee2a8,
    name: "customer"
  }, {
    path: "/details",
    component: _610c5864,
    name: "details"
  }, {
    path: "/goals",
    component: _7704efe8,
    name: "goals"
  }, {
    path: "/maisoku",
    component: _4500a432,
    name: "maisoku"
  }, {
    path: "/media",
    component: _4957b730,
    name: "media"
  }, {
    path: "/privacy",
    component: _7899ffd1,
    name: "privacy"
  }, {
    path: "/project",
    component: _5e156836,
    name: "project"
  }, {
    path: "/response",
    component: _51ec974b,
    name: "response"
  }, {
    path: "/sale",
    component: _37db395e,
    name: "sale"
  }, {
    path: "/achievement/output",
    component: _2607aba8,
    name: "achievement-output"
  }, {
    path: "/achievement/registration",
    component: _af3e0fc0,
    name: "achievement-registration"
  }, {
    path: "/advertise/analysis",
    component: _014fe20b,
    name: "advertise-analysis"
  }, {
    path: "/advertise/management",
    component: _43ced232,
    name: "advertise-management"
  }, {
    path: "/advertise/registration",
    component: _78f38430,
    name: "advertise-registration"
  }, {
    path: "/calendar/registration",
    component: _133d351a,
    name: "calendar-registration"
  }, {
    path: "/customer/registration",
    component: _10b6965a,
    name: "customer-registration"
  }, {
    path: "/goals/analysis",
    component: _533d3692,
    name: "goals-analysis"
  }, {
    path: "/goals/setting",
    component: _fa58c3ec,
    name: "goals-setting"
  }, {
    path: "/line/tracking",
    component: _4addaf3e,
    name: "line-tracking"
  }, {
    path: "/maisoku/export",
    component: _95f49f22,
    name: "maisoku-export"
  }, {
    path: "/maisoku/template",
    component: _7b8dcd16,
    name: "maisoku-template"
  }, {
    path: "/response/registration",
    component: _07d412d0,
    name: "response-registration"
  }, {
    path: "/sale/output",
    component: _28643f12,
    name: "sale-output"
  }, {
    path: "/setting/announcement",
    component: _2fbf2620,
    name: "setting-announcement"
  }, {
    path: "/setting/import",
    component: _33dd484e,
    name: "setting-import"
  }, {
    path: "/setting/mail-template",
    component: _5d22945a,
    name: "setting-mail-template"
  }, {
    path: "/setting/matching-mail",
    component: _1388eade,
    name: "setting-matching-mail"
  }, {
    path: "/setting/shop",
    component: _a4056f48,
    name: "setting-shop"
  }, {
    path: "/setting/staff",
    component: _54de2f26,
    name: "setting-staff"
  }, {
    path: "/setting/step-mail",
    component: _1817f6a5,
    name: "setting-step-mail"
  }, {
    path: "/setting/tag",
    component: _7d0db927,
    name: "setting-tag"
  }, {
    path: "/shop/document-template",
    component: _6ea4005d,
    name: "shop-document-template"
  }, {
    path: "/shop/message",
    component: _563ebd90,
    name: "shop-message"
  }, {
    path: "/message/line/edit",
    component: _669bdfc6,
    name: "message-line-edit"
  }, {
    path: "/message/line/log",
    component: _18ffa990,
    name: "message-line-log"
  }, {
    path: "/message/line/registration",
    component: _e7d07c90,
    name: "message-line-registration"
  }, {
    path: "/message/line/select",
    component: _d0733690,
    name: "message-line-select"
  }, {
    path: "/message/line/send",
    component: _51795244,
    name: "message-line-send"
  }, {
    path: "/message/mail/log",
    component: _c707e40a,
    name: "message-mail-log"
  }, {
    path: "/message/mail/registration",
    component: _1e848f92,
    name: "message-mail-registration"
  }, {
    path: "/message/mail/select",
    component: _6fffe715,
    name: "message-mail-select"
  }, {
    path: "/message/mail/send",
    component: _700c703e,
    name: "message-mail-send"
  }, {
    path: "/setting/announcement/registration",
    component: _1e8eecea,
    name: "setting-announcement-registration"
  }, {
    path: "/setting/import/Detail",
    component: _56f0ad25,
    name: "setting-import-Detail"
  }, {
    path: "/setting/import/registration",
    component: _00e46f26,
    name: "setting-import-registration"
  }, {
    path: "/setting/real-estate-agent/property-range",
    component: _e17a8ab2,
    name: "setting-real-estate-agent-property-range"
  }, {
    path: "/setting/staff/registration",
    component: _226ad124,
    name: "setting-staff-registration"
  }, {
    path: "/setting/step-mail/registration",
    component: _20199a36,
    name: "setting-step-mail-registration"
  }, {
    path: "/message/line/registration/success",
    component: _ef13862e,
    name: "message-line-registration-success"
  }, {
    path: "/",
    component: _177e085b,
    name: "index"
  }, {
    path: "/message/mail/edit/:id?",
    component: _351d398e,
    name: "message-mail-edit-id"
  }, {
    path: "/agreement/log/:id?",
    component: _7486f11a,
    name: "agreement-log-id"
  }, {
    path: "/agreement/registration/:id?",
    component: _0dcd4990,
    name: "agreement-registration-id"
  }, {
    path: "/customer/edit/:id?",
    component: _06dc274f,
    name: "customer-edit-id"
  }, {
    path: "/media/registration/:id?",
    component: _735a3114,
    name: "media-registration-id"
  }, {
    path: "/project/registration/:id?",
    component: _6ecabfa1,
    name: "project-registration-id"
  }, {
    path: "/response/add/:id?",
    component: _b29606f6,
    name: "response-add-id"
  }, {
    path: "/setting/announcement/:id",
    component: _15c4eb58,
    name: "setting-announcement-id"
  }, {
    path: "/setting/staff/:id",
    component: _61afbbd6,
    name: "setting-staff-id"
  }, {
    path: "/setting/step-mail/:id?",
    component: _360d5e4d,
    name: "setting-step-mail-id"
  }, {
    path: "/shop/message/:id",
    component: _541591a0,
    name: "shop-message-id"
  }, {
    path: "/achievement/:id",
    component: _afaa5dba,
    name: "achievement-id"
  }, {
    path: "/agreement/:id",
    component: _f14ffd84,
    name: "agreement-id"
  }, {
    path: "/client-history/:id?",
    component: _fa5be6f8,
    name: "client-history-id"
  }, {
    path: "/customer/:id",
    component: _50856f10,
    name: "customer-id"
  }, {
    path: "/media/:id",
    component: _24c9c598,
    name: "media-id"
  }, {
    path: "/project/:id",
    component: _5681f8e6,
    name: "project-id"
  }, {
    path: "/property/:property?",
    component: _e6e8ca7e,
    name: "property-property",
    children: [{
      path: "contact",
      component: _73a4d355,
      name: "property-property-contact"
    }, {
      path: "contact/confirm",
      component: _21255b83,
      name: "property-property-contact-confirm"
    }, {
      path: "contact/send",
      component: _4f9283d5,
      name: "property-property-contact-send"
    }]
  }, {
    path: "/response/:id",
    component: _cc841f1a,
    name: "response-id"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
